import SampleComponent from './SampleComponent';
import LoadMore from './LoadMore';
import Flickity from './Flickity';
import Guide from './Guide';
import Map from './Map';
import Tabs from './Tabs';
import Scrollbar from './Scrollbar';
import ToggleClass from './ToggleClass';
import Question from './Question';
import RewardModal from './RewardModal';
import PageView from './PageView';
import Video from './Video';
import VideoModal from './VideoModal';
import ProgressLine from './ProgressLine';

const Components = {
    Flickity: Flickity,
    LoadMore: LoadMore,
    Guide: Guide,
    Map: Map,
    Tabs: Tabs,
    Scrollbar: Scrollbar,
    ToggleClass: ToggleClass,
    Question: Question,
    RewardModal: RewardModal,
    PageView: PageView,
    Video: Video,
    VideoModal: VideoModal,
    ProgressLine: ProgressLine,
};

export default Components;


// WEBPACK FOOTER //
// ./components/index.js